import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';

export function provideGraphQL() {
    return provideApollo(() => {
        const httpLink = inject(HttpLink);

        return {
            link: httpLink.create({
                uri: environment.graphqlEndpoint,
                withCredentials: true,
            }),
            cache: new InMemoryCache({
                typePolicies: {
                    Query: {
                        fields: {
                            churches: { merge: false },
                            members: { merge: false },
                            events: { merge: false },
                            donations: { merge: false },
                        },
                    },
                },
            }),
            defaultOptions: {
                watchQuery: {
                    fetchPolicy: 'cache-and-network',
                    errorPolicy: 'all',
                },
                query: {
                    fetchPolicy: 'network-only',
                    errorPolicy: 'all',
                },
                mutate: {
                    errorPolicy: 'all',
                },
            },
        };
    });
}
